export default "__VITE_ASSET__CBlBNEe6__"